module.exports = __webpack_public_path__ + "img/32737-252.1dbcb721.jpg";